import {
  React,
  useState,
  createContext,
  useContext
} from 'react';
import api from 'src/services/api';
import { SiteContext } from './SiteContext';

export const UserContext = createContext();

const UserProvider = (prop) => {
  const baseUrl = 'admin';
  const { children } = prop;
  const [user, setUser] = useState(null);
  const [logedUser, setLogedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [urlPaginate, setUrlPaginate] = useState();
  const {
    setNotifyMessage,
    notifyMessageSave,
    closeNotifyMessage,
    notifyMessageError,
    loading,
    setLoading
  } = useContext(SiteContext);
  const [search, setSearch] = useState();

  const getUsers = async () => {
    setLoading(true);
    await api.get(`${baseUrl}/all`)
      .then((response) => {
        setUsers(response.data);
        setUrlPaginate(response.data.meta.path);
        setLoading(false);
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
  };

  const getUser = async (id) => {
    setLoading(true);
    await api.get(`${baseUrl}/get/${id}`)
      .then((response) => {
        setUser(response.data.data);
        setLoading(false);
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
  };

  const getUserByToken = async () => {
    setLoading(true);
    await api.get(`${baseUrl}/byToken`)
      .then((response) => {
        setLogedUser(response.data.data);
        setLoading(false);
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
  };

  const loginUser = async (data) => {
    setLoading(true);
    const serverResponse = await api.post('admin/login', data)
      .then((response) => {
        sessionStorage.setItem('authorization', response.data.token);
        sessionStorage.setItem('user', response.data.user);
        sessionStorage.setItem('image', response.data.image);
        setLogedUser(response.data);
        setLoading(false);
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
    return serverResponse;
  };

  const saveUser = async (data) => {
    setLoading(true);
    const serverResponse = await api.post(`${baseUrl}/create`, data)
      .then((response) => {
        setUser(response.data.data);
        setLoading(false);
        notifyMessageSave('Salvo');
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
    return serverResponse;
  };

  const updateUser = async (id, data) => {
    setLoading(true);
    await api.post(`${baseUrl}/update/${id}`, data)
      .then((response) => {
        setUser(response.data.data);
        setLoading(false);
        notifyMessageSave('Atualizado');
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
  };

  const searchUsers = async (param) => {
    setLoading(true);
    if (!param) {
      await getUsers();
    } else {
      await api.post(`${baseUrl}/search`, { param })
        .then((response) => {
          setUsers(response.data);
          setUrlPaginate(response.data.meta.path);
          setSearch(param);
          setLoading(false);
        })
        .catch((err) => {
          setUsers([]);
          setLoading(false);
          console.log(err);
        });
    }
  };

  const paginateUser = async (number) => {
    setLoading(true);
    if (search) {
      await api.post(`${urlPaginate}?page=${number}`, { search })
        .then((response) => {
          setUsers(response.data);
          setLoading(false);
        })
        .catch((err) => {
          setUsers([]);
          setLoading(false);
          console.log(err);
        });
    } else {
      await api.get(`${urlPaginate}?page=${number}`)
        .then((response) => {
          setUsers(response.data);
          setLoading(false);
        })
        .catch((err) => {
          setUsers([]);
          setLoading(false);
          console.log(err);
        });
    }
  };

  const deleteUser = async (id) => {
    setLoading(true);
    const response = await api.delete(`${baseUrl}/delete/${id}`)
      .then(() => {
        setLoading(false);
        notifyMessageSave('excluido');
        getUsers();
        return true;
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        return false;
      });
    return response;
  };

  return (
    <UserContext.Provider
      value={{
        user,
        users,
        logedUser,
        loading,
        urlPaginate,
        getUsers,
        saveUser,
        updateUser,
        setUser,
        deleteUser,
        paginateUser,
        getUser,
        getUserByToken,
        setLogedUser,
        setNotifyMessage,
        loginUser,
        searchUsers,
        closeNotifyMessage,
        notifyMessageError,
        notifyMessageSave
      }}
    >
      { children }
    </UserContext.Provider>

  );
};

export default UserProvider;
